import 'bootstrap-sass';
import 'jquery-match-height';
import 'jquery.easing';

// import { pageTop } from "./modules/page-top";
// import { jqueryvalidation } from "./modules/jqueryvalidation";
// import {waypoints} from "./modules/waypoints";

import "./modules/webfont";
import {smoothScroll} from "./modules/smoothScroll";
import {menuTrigger} from "./modules/menu-trigger";

import './modules/swiper-fv';
import './modules/swiper-business-model';
import './modules/swiper-vendors';

import './modules/btn-page-top';
import './modules/checkbox-active';
import './modules/table-match-height';
import './modules/dropdown-hover';

import './modules/wp-members/form-register';
import './modules/wp-members/form-login';
// import './modules/wp-members/user-form';

import './modules/form-checkbox-franchise';
import './modules/fullcalendar';

import './modules/form';
import './modules/form-confirm';

import './modules/single-project';
